import { actionClient } from '@/api'

const formatSetting = function(settings) {
  const result = {};
  settings.forEach((item, index) => {
    let hasNumber = item.value.length
    let needNumber = 0
    switch (item.name) {
      case 'new-product' :
          needNumber = 3 - hasNumber
          break;
      case 'organ' :
        needNumber = 2 - hasNumber
        break;
      case 'piano' :
        needNumber = 4 - hasNumber
        break;
    }

    for (needNumber; needNumber > 0; needNumber--) {
      item.value.push({})
    }
    result[item.name] = item
  })
  return result
}

const stage = 'new-product-setting'

export default {

  namespaced: true,

  state: {
    settings: {
      'new-product' : { value: []},
      'piano' : { value: []},
      'organ' : { value: []},
    },
  },


  mutations: {
    setSettings(state, $data) {
      state.settings = formatSetting($data)
    }
  },

  actions: {
    async create({ commit }, { info, name }) {
      return await actionClient.post('new-product-setting', { info, name, stage })
    },

    async update({ commit }, { info, name }) {
      return await actionClient.update('new-product-setting', { info, name, stage })
    },

    async getSettings({ commit }) {
      const settings = await actionClient.get(stage)
      commit('setSettings', settings)
    },

    async getSettingByIndex({state, dispatch}, {index, type}) {
      await dispatch('getSettings')
      return state.settings[type].value[index]
    }
  }


}
